// extracted by mini-css-extract-plugin
export var activityContainer = "_ka-0";
export var typingIndicatorContainer = "_ka-1";
export var typingIndicatorDot = "_ka-2";
export var wave = "_ka-3";